import { privateAxios, publicAxios } from "@src/axios.config"

export const getPackages = async (role, userId = null) => {
    let url = `/payments/packages/?role=${role}`;
    if (userId) {
        url += `&user_id=${userId}`;
    }
    return await publicAxios.get(url)
}

export const initializePayment = async (
  id,
  userId,
  role,
  selected_features,
  active_jobs_count,
  paygCounts = {}
) => {
  const body = {
    role,
    package_id: id,
    user_id: userId,
    selected_features,
    active_jobs_count: active_jobs_count ?? 0,
  };
  if (paygCounts && typeof paygCounts === "object") {
    if (paygCounts.sheets_count != null) body.sheets_count = paygCounts.sheets_count;
    if (paygCounts.users_count != null) body.users_count = paygCounts.users_count;
    if (paygCounts.meetings_count != null) body.meetings_count = paygCounts.meetings_count;
    if (paygCounts.chat_users_count != null) body.chat_users_count = paygCounts.chat_users_count;
    if (paygCounts.resumes_count != null) body.resumes_count = paygCounts.resumes_count;
    if (paygCounts.notes_count != null) body.notes_count = paygCounts.notes_count;
    if (paygCounts.note_attachments_per_note_count != null) body.note_attachments_per_note_count = paygCounts.note_attachments_per_note_count;
    if (paygCounts.max_meeting_participants != null) body.max_meeting_participants = paygCounts.max_meeting_participants;
  }
  return await privateAxios.post(`/payments/init_payment`, body);
};

export const modifyPaygSubscription = async (payload) => {
  // payload = {
  //   selected_features: number[],   // Feature ids for non-bucket features
  //   active_jobs_count, sheets_count, users_count, meetings_count,
  //   chat_users_count, resumes_count, notes_count, max_meeting_participants
  // }
  // Edits the EXISTING pay-as-you-go subscription in place — no new checkout,
  // no new subscription, renewal date unchanged.
  return await publicAxios.post("/api/payg/modify/", payload);
};

export const getFeatures = async () => {
    return await privateAxios.get(`/payments/features`)
}

export const getPayments = async ()=>{
    return await privateAxios.get(`/payments/payment_plan`)
}

export const cancelSubscription = async (cancellation_type = "end_of_period", package_type = null) => {
    const data = { cancellation_type };
    if (package_type) {
        data.package_type = package_type;
    }
    return await privateAxios.post(`/payments/cancel_subscription`, data);
}

export const reactivateSubscription = async () => {
  const response = await privateAxios.post(`/payments/reactivate_subscription`);
  return response.data;
};

export const buyExtraJobSlot = async () => {
  const response = await privateAxios.post(`/payments/buy-extra-job/`);   // trailing slash
  return response.data;
};

export const confirmExtraJobSlot = async (sessionId) => {
  const response = await privateAxios.post(`/payments/confirm-extra-job/`, {  // trailing slash
    session_id: sessionId,
  });
  return response.data;
};

export const getJobQuotaRemaining = async (jobIds = []) => {
  const response = await privateAxios.post(`/payments/job-quota-remaining/`, {
    job_ids: jobIds,
  });
  return response.data;
  // { remaining, limit, extra_slots, posted_this_period, new_count, free_count }
};

// Get transaction history
export const getTransactionHistory = async () => {
    return await privateAxios.get('/payments/transactions');
}

// Get saved cards
export const getSavedCards = async () => {
    return await privateAxios.get('/payments/saved-cards');
}

// Update card (set as default or update billing details)
export const updateCard = async (paymentMethodId, action, billingDetails = null) => {
    const data = {
        payment_method_id: paymentMethodId,
        action: action  // 'set_default' or 'update_billing'
    };
    if (billingDetails) {
        data.billing_details = billingDetails;
    }
    return await privateAxios.post('/payments/update-card', data);
}

// Change card: opens Stripe Checkout to enter a new card
export const startCardUpdate = async (paymentMethodId, returnUrl) => {
    return await privateAxios.post('/payments/update-card', {
        payment_method_id: paymentMethodId,
        action: 'start_card_update',
        return_url: returnUrl,
    });
}

// Change card: called after the user returns from Stripe Checkout
export const finishCardUpdate = async (sessionId) => {
    return await privateAxios.post('/payments/update-card', {
        action: 'finish_card_update',
        session_id: sessionId,
    });
}

// Delete card
export const deleteCard = async (paymentMethodId) => {
    return await privateAxios.delete(`/payments/delete-card/${paymentMethodId}`);
}

export const createBillingPortalSession = async (returnUrl) => {
    return await privateAxios.post('/payments/billing-portal-session', {
        return_url: returnUrl,
    });
};

// Subscribe to free plan (for candidates)
export const subscribeFreePlan = async (userId) => {
    return await privateAxios.post('/payments/subscribe_free_plan', {
        user_id: userId
    });
}

export const getMyPlanMigration = async () => {
  const response = await privateAxios.get(`/payments/my-plan-migration/`);
  return response.data;
};

export const getMyScheduledChange = async () => {
  const response = await privateAxios.get(`/payments/my-scheduled-change/`);
  return response.data;
};
